




























































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import AgendamentoBackofficeAutorizacaoStore from '@/components/AgendamentoBackoffice/Store/AgendamentoBackofficeAutorizacaoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import BackofficeFarmaciaStore from '@/components/Backoffice/Store/BackofficeFarmaciaStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { humanTime, displayColorBySituation, displayColorByStatus, timeoutDefault, groupCollectionByField, maskHour, maskDate, lembreteColor, verifyAcoesFarmacia, getHospitalAreaName, formatStatusSituacaoFarmacia, backofficeRoute } from '@/utils/common'
import { CancelarSolicitacaoParam, StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, AgendamentoCirurgia, Solicitacao, SituacaoEnum, TipoMensagemEnum, PendenciaMensagem, TipoDocumentoUpload, AgendamentoSolicitacaoItem, TipoOrigemEnum, User } from '@/types/_'
import { IPendenciaSolicitacao, PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import { Agendamento, Cancelamento } from '@/types/core'
import { Acoes } from '@/types/interfaces/Solicitacao'
import Chat from '@/views/backoffice-chat/chat/chat.vue'
/* EventBus */
import EventBus from '@/plugins/EventBus'
import ChatSolicitacaoComentarioStore from '@/components/chat-solicitacao-comentario/store/chat-solicitacao-comentario-store'
import BackofficeModalChatStore from '@/views/backoffice-chat/store/backoffice-modal-chat-store'
import BackofficeChatStore from '@/views/backoffice-chat/store/backoffice-chat-store'

@Component({
  filters: { humanTime },
  components: {
    Chat,
  },
})
export default class ViewBackofficeFarmacia extends Vue {
  $refs!: {
    cancelamentoForm: any,
    chatScrollContent: HTMLElement,
    cirurgiaDe: any,
    cirurgiaAte: any,
  }

  cancelamentoForm: any = {
    valid: false,
    motivo: [
      v => !!v || 'O campo motivo é obrigatório.',
    ],
  }

  $user: User;

  readyState: boolean = false
  modalPendencia: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  loadRespondePendencia: string = ''
  loadEncerrarPendencia: boolean = false
  loadConfirmarEncerrarPendencia: boolean = false
  loadClosePedencia: boolean = false
  modalConfirmarEncerrarPendencia: boolean = false
  modalCancelamento: boolean = false
  loadCloseConfiramrEncerrarPendencia: boolean = false
  loadCloseCancelamento: boolean = false
  loadConfirmarCancelamento: boolean = false
  loadCancelamento: string = ''
  loadHistorico: string = ''
  loadComentario: string = ''
  loadNovaDataSolicitada: string = ''
  loadDesfazerCancelamento: string = ''
  mensagem: string = ''
  loadingPendenciaAdministrativa = ''
  loadingFinalizaSolicitacaoNaFarmacia = ''
  displayPendencia: any = {
    nomePaciente: '',
    nomeMedico: '',
  }

  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()
  cancelamento: Cancelamento.ICancelamento = new Cancelamento.Cancelamento()
  areaDoHospital: any = getHospitalAreaName()

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  get loadingNovaDataSolicitada() {
    return this.loadNovaDataSolicitada
  }

  set loadingNovaDataSolicitada(value: string) {
    this.loadNovaDataSolicitada = value
  }

  get loadingConfirmarCancelamento() {
    return this.loadConfirmarCancelamento
  }

  set loadingConfirmarCancelamento(value: boolean) {
    this.loadConfirmarCancelamento = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: string) {
    this.loadCancelamento = value
  }

  get loadingCloseCancelamento() {
    return this.loadCloseCancelamento
  }

  set loadingCloseCancelamento(value: boolean) {
    this.loadCloseCancelamento = value
  }

  get showModalCancelamento() {
    return this.modalCancelamento
  }

  set showModalCancelamento(value: boolean) {
    this.modalCancelamento = value
  }

  get loadingComentario() {
    return this.loadComentario
  }

  set loadingComentario(value: string) {
    this.loadComentario = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get loadingCloseConfirmarEncerrarPendencia() {
    return this.loadCloseConfiramrEncerrarPendencia
  }

  set loadingCloseConfirmarEncerrarPendencia(value: boolean) {
    this.loadCloseConfiramrEncerrarPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get showModalConfirmarEncerrarPendencia() {
    return this.modalConfirmarEncerrarPendencia
  }

  set showModalConfirmarEncerrarPendencia(value: boolean) {
    this.modalConfirmarEncerrarPendencia = value
  }

  get loadingConfirmarEncerrarPendencia() {
    return this.loadConfirmarEncerrarPendencia
  }

  set loadingConfirmarEncerrarPendencia(value: boolean) {
    this.loadConfirmarEncerrarPendencia = value
  }

  get showModalPendenciaAgendamento() {
    return this.modalPendencia
  }

  set showModalPendenciaAgendamento(value: boolean) {
    this.modalPendencia = value
  }

  get getDisplayPendencia() {
    return this.displayPendencia
  }

  set getDisplayPendencia(value: any) {
    this.displayPendencia = value
  }

  get loadingEncerrarPendencia() {
    return this.loadEncerrarPendencia
  }

  set loadingEncerrarPendencia(val: boolean) {
    this.loadEncerrarPendencia = val
  }

  get loadingRespondePendencia() {
    return this.loadRespondePendencia
  }

  set loadingRespondePendencia(value: string) {
    this.loadRespondePendencia = value
  }

  get loadingDesfazerCancelamento() {
    return this.loadDesfazerCancelamento
  }

  set loadingDesfazerCancelamento(value: string) {
    this.loadDesfazerCancelamento = value
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getMotivo() {
    return this.getSolicitacaoCancelamentoStore.motivo
  }

  set getMotivo(value: string) {
    this.getSolicitacaoCancelamentoStore.setMotivo(value)
  }

  get getObservacaoDoCancelamento() {
    return this.getSolicitacaoCancelamentoStore.observacaoDoCancelamento
  }

  set getObservacaoDoCancelamento(message: string) {
    this.getSolicitacaoCancelamentoStore.setObservacaoCancelamento(message)
  }

  get getMotivoMessage() {
    return this.getSolicitacaoCancelamentoStore.motivoMessage
  }

  set getMotivoMessage(value: string) {
    this.getSolicitacaoCancelamentoStore.setMotivoMessage(value)
  }

  get getMotivos() {
    return this.getSolicitacaoCancelamentoStore.motivosCancelamento
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getBackofficeDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }

  get getHabilitarObservacaoDoCancelamento() {
    return this.getSolicitacaoCancelamentoStore.habilitarObservacaoDoCancelamento
  }

  get chatSolicitacaoComentarioStore() {
    return getModule(ChatSolicitacaoComentarioStore, this.$store)
  }

  scrollToMensagem() {
    if (this.$refs.chatScrollContent) {
      setTimeout(() => {
        const elem = this.$refs.chatScrollContent

        const option: ScrollToOptions = {
          behavior: 'smooth',
          left: 0,
          top: elem.scrollHeight,
        }
        elem.scrollTo(option)
      }, 0)
    }
  }

  @Watch('showModalPendencia')
  onChangeShowModalPendencia() {
    this.scrollToMensagem()
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  formatDate(value: string) {
    return maskDate(value)
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return response.habilitado
    }

    return false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
    this.getBackofficeFarmaciaStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async showModalNovaDataSolicitada(agendamentoItem: AgendamentoSolicitacaoItem) {
    this.loadingNovaDataSolicitada = agendamentoItem.id

    await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoItem.id)

    if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoItem.id)
      if (response.success) {
        await this.getChatStore.getDataAgendamento(agendamentoItem.id)
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoItem.hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      await this.getChatStore.getDataAgendamento(agendamentoItem.id)
      await this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...agendamentoItem })
      this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
    }

    this.loadingNovaDataSolicitada = ''
    this.ga('backoffice-agendamento', 'confirmar-data')
  }

  async showModalDesfazerCancelamento(agendamentoItem: AgendamentoSolicitacaoItem) {
    this.loadingDesfazerCancelamento = agendamentoItem.id

    await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoItem.id)

    if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoItem.id)
      if (response.success) {
        await this.getChatStore.getDataAgendamento(agendamentoItem.id)
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoItem.hospitalId)
        // Cria a flag desfazCancelamento para diferenciar a modal de alterar reserva...
        this.getBackofficeGlobalStore.setDesfazCancelamento(true)
        this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
      }
    } else {
      await this.getChatStore.getDataAgendamento(agendamentoItem.id)
      await this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...agendamentoItem })
      // Cria a flag desfazCancelamento para diferenciar a modal de alterar reserva...
      this.getBackofficeGlobalStore.setDesfazCancelamento(true)
      this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
    }

    this.loadingDesfazerCancelamento = ''
    this.ga('backoffice-agendamento', 'desfazer-cancelamento')
  }

  async showModalCancelamentoBtn(agendamentoCirurgia: any) {
    this.loadingCancelamento = agendamentoCirurgia.id
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: agendamentoCirurgia.id || '',
      tipoOrigem: TipoOrigemEnum.Agendamento,
      canceladoMotivo: agendamentoCirurgia.canceladoMotivo,
      situacao: {
        display: '',
        key: '',
      },
      modal: '',
    }

    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: agendamentoCirurgia.hospitalId })
    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.showModalCancelamento = true
    this.loadingCancelamento = ''
  }

  async confirmarCancelamento() {
    if (this.$refs.cancelamentoForm.validate()) {
      this.loadingConfirmarCancelamento = true
      const { solicitacaoId } = this.getSolicitacaoCancelamentoStore.cancelarSolicitacaoParam
      const params: any = {
        solicitacaoId,
        tipoOrigem: TipoOrigemEnum.Agendamento,
        motivoCancelamento: this.getMotivo,
        observacaoDoCancelamento: this.getObservacaoDoCancelamento,
      }

      const response = await this.cancelamento.cancelarSolicitacao(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação cancelada com sucesso.', icon: 'done', color: '#2E7D32' })
        this.getBackofficeFarmaciaStore.deleteSolicitacao(solicitacaoId)
        this.closeModalCancelamento()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }

      this.$refs.cancelamentoForm.reset()
      this.loadingConfirmarCancelamento = false
    }
  }

  async closeModalCancelamento() {
    this.showModalCancelamento = false
    this.getSolicitacaoCancelamentoStore.clear()
  }

  async voltarCancelamentoBtn() {
    this.loadingCloseCancelamento = true
    await timeoutDefault()
    this.loadingCloseCancelamento = false
    this.showModalCancelamento = false
    this.$refs.cancelamentoForm.reset()
  }

  async confirmarEncerrarPendenciaCloseModal() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalConfirmarEncerrarPendencia = true
    this.loadingClosePendencia = false
  }

  async closeEncerrarPendenciaCloseModal() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingCloseConfirmarEncerrarPendencia = true
    await this.agendamento.desbloquearSolicitacao(solicitacaoId)
    this.closeModalPendencia()
  }

  async closeModalPendencia() {
    await timeoutDefault()
    this.showModalPendencia = false
    this.showModalConfirmarEncerrarPendencia = false

    this.loadingCloseConfirmarEncerrarPendencia = false
    this.loadingEncerrarPendencia = false
    this.getDisplayPendencia = {
      nomePaciente: '',
      nomeMedico: '',
    }
    this.getPendenciaStore.clearPendencia()
  }

  async showModalRespondePendencia(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    const { hospitalId } = agendamentoCirurgia
    this.loadingRespondePendencia = solicitacaoId

    let response = await this.agendamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getPendenciaStore.getPendencias(solicitacaoId)
      if (response.success) {
        this.getDisplayPendencia = {
          nomePaciente: agendamentoCirurgia.pacienteNome,
          nomeMedico: agendamentoCirurgia.medicoNome,
        }
        this.showModalPendencia = true
        this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
        this.getBackofficeGlobalStore.setHospitalId(hospitalId)
      } else {
        await this.showModalTriagem(agendamentoCirurgia)
        this.getBackofficeFarmaciaStore.deleteSolicitacao(solicitacaoId)
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'done', color: '#2E7D32' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadRespondePendencia = ''
    this.ga('backoffice-autorizacao', 'responder-pendencia-autorizacao')
  }

  async encerrarPendencia() {
    this.loadingEncerrarPendencia = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.openModalFlow(this.getBackofficeGlobalStore.solicitacao as any)
      this.getBackofficeFarmaciaStore.deleteSolicitacao(solicitacaoId)
      await this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    let response = await this.getPendenciaStore.uploadDocumento(param)
    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeFarmaciaStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      }
    }

    this.loadingUpload = false
  }

  async confirmarEncerrarPendencia() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingConfirmarEncerrarPendencia = true
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.showModalTriagem(this.getBackofficeGlobalStore.solicitacao)
      this.getBackofficeFarmaciaStore.deleteSolicitacao(solicitacaoId)
      this.agendamento.desbloquearSolicitacao(solicitacaoId)
      this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarEncerrarPendencia = false
  }

  /**
   * Fim - Pendência
   */

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem reserva'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    return 'Sem reserva'
  }

  hTime(s: string) {
    return humanTime(s)
  }

  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true, width: '300px' },
    { text: 'Convênio', value: 'convenioNome', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false, active: true },
    { text: 'Situação', value: 'statusSituacaoFarmacia', sortable: false, active: true },
    { text: 'Status da cirurgia', value: 'statusCirurgia', sortable: false, active: true },
    { text: 'Data de validade', value: 'autorizacaoValidade', align: 'center', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: '', sortable: false, active: true },
  ]

  getRequestMessage: IRequestMessage = new RequestMessage()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  inputFiles: any[] = []

  loadRealizarPreAgendamento: string = ''
  loadRealizarRevisaoCirurgica: string = ''
  loadRealizarTriagem: string = ''
  loadVisualizar: string = ''
  modDe: boolean = false
  modAte: boolean = false

  agendamento: Agendamento.IAgendamento = new Agendamento.Agendamento()

  get loadingRealizarPreAgendamento() {
    return this.loadRealizarPreAgendamento
  }

  set loadingRealizarPreAgendamento(value: string) {
    this.loadRealizarPreAgendamento = value
  }

  get loadingRealizarRevisaoCirurgica() {
    return this.loadRealizarRevisaoCirurgica
  }

  set loadingRealizarRevisaoCirurgica(value: string) {
    this.loadRealizarRevisaoCirurgica = value
  }

  get loadingRealizarTriagem() {
    return this.loadRealizarTriagem
  }

  set loadingRealizarTriagem(value: string) {
    this.loadRealizarTriagem = value
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: string) {
    this.loadVisualizar = val
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  get getBackofficeFarmaciaStore() {
    return getModule(BackofficeFarmaciaStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get solicitacoes() {
    return this.getBackofficeFarmaciaStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficeFarmaciaStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeFarmaciaStore.setFilterDrawer(value)
  }

  get hospitalFazOrcamentoParticularAvulso() {
    return this.getBackofficeFarmaciaStore.hospitais.some((h: any) => h.hospitalFazOrcamentoParticularAvulso)
  }

  get etapa() {
    return this.getBackofficeFarmaciaStore.situacoes
  }

  set etapa(value: any) {
    this.getBackofficeFarmaciaStore.setSituacoes(value.key)
  }

  get etapas() {
    return [
      { key: 'pendenteReserva', display: 'Pendente de reserva', quantidade: this.getPendenteReservaTotal },
      { key: 'pendenteAjusteData', display: 'Pendente de ajuste de data', quantidade: this.getPendenteAjusteDataTotal },
      { key: 'pendenteAjusteMaterial', display: 'Pendente de ajuste de material', quantidade: this.getPendenteAjusteMaterialTotal },
      { key: 'pendenteCancelamento', display: 'Pendente de cancelamento', quantidade: this.getPendenteCancelamentoTotal },
      { key: 'concluido', display: 'Concluído', quantidade: this.getConcluidoTotal },
    ]
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get todosOsStatus() {
    return this.getBackofficeFarmaciaStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficeFarmaciaStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficeFarmaciaStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficeFarmaciaStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  async selectAllFromHospital() {
    await this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  async selectAllFromArea() {
    await this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  async selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficeFarmaciaStore.clearSituacoes()
    }
    this.etapa = item
  }

  async filterSituacao() {
    this.getBackofficeFarmaciaStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getBackofficeFarmaciaStore.loadAgendamentosMedicoSearch()
    EventBus.$emit('clearLoadingRequest')
  }

  get getPendenteReservaTotal() {
    if (this.getBackofficeFarmaciaStore.situacoesCounter.length > 0
      && this.getBackofficeFarmaciaStore.situacoesCounter.filter(d => d.key === SituacaoEnum.PendenteReserva).length > 0) {
      return this.getBackofficeFarmaciaStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteReserva)[0].quantidade
    }
    return 0
  }

  get getPendenteAjusteDataTotal() {
    if (this.getBackofficeFarmaciaStore.situacoesCounter.length > 0
      && this.getBackofficeFarmaciaStore.situacoesCounter.filter(d => d.key === SituacaoEnum.PendenteAjusteData).length > 0) {
      return this.getBackofficeFarmaciaStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteAjusteData)[0].quantidade
    }
    return 0
  }

  get getPendenteAjusteMaterialTotal() {
    if (this.getBackofficeFarmaciaStore.situacoesCounter.length > 0
      && this.getBackofficeFarmaciaStore.situacoesCounter.filter(d => d.key === SituacaoEnum.PendenteAjusteMaterial).length > 0) {
      return this.getBackofficeFarmaciaStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteAjusteMaterial)[0].quantidade
    }
    return 0
  }

  get getPendenteCancelamentoTotal() {
    if (this.getBackofficeFarmaciaStore.situacoesCounter.length > 0
      && this.getBackofficeFarmaciaStore.situacoesCounter.filter(d => d.key === SituacaoEnum.PendenteCancelamento).length > 0) {
      return this.getBackofficeFarmaciaStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteCancelamento)[0].quantidade
    }
    return 0
  }

  get getConcluidoTotal() {
    if (this.getBackofficeFarmaciaStore.situacoesCounter.length > 0
      && this.getBackofficeFarmaciaStore.situacoesCounter.filter(d => d.key === SituacaoEnum.Concluido).length > 0) {
      return this.getBackofficeFarmaciaStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Concluido)[0].quantidade
    }
    return 0
  }

  get getTotal() {
    return this.getBackofficeFarmaciaStore.totalSolicitacoes || 0
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get de() {
    return this.getBackofficeFarmaciaStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficeFarmaciaStore.setDeFiltro(value)
  }

  get ate() {
    return this.getBackofficeFarmaciaStore.ateFiltro
  }

  set ate(value: Date | string | null) {
    this.getBackofficeFarmaciaStore.setAteFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get formattedAte() {
    return this.formatDateRange(this.ate)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  get modalAte() {
    return this.modAte
  }

  set modalAte(value: boolean) {
    this.modAte = value
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  resetModalAte() {
    this.ate = null
    this.modalAte = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
      this.ate = null
    } else {
      this.ate = null
    }
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  verifyAcoes(item: any) {
    return verifyAcoesFarmacia(item)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  getColor(status: string) {
    switch (status) {
      case 'Apto':
        return { color: 'green dark-2', icon: 'thumb_up', tooltip: 'Paciente apto para cirurgia' }
      case 'AptoComAtencao':
        return { color: 'yellow darken-3', icon: 'thumb_up', tooltip: 'Verificar alterações feitas pelo anestesista' }
      case 'NaoApto':
        return { color: 'red darken-3', icon: 'thumb_down', tooltip: 'Paciente não está apto para cirurgia' }
      default:
        return { color: 'orange darken-4', icon: 'schedule', tooltip: 'Avaliação pré-anestésica pendente' }
    }
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.ordenarPorTriagemPrioritaria) {
      classes.push('backoffice-list-table-row__triagem-prioritaria')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('backoffice-list-table-row__auditada')
    }

    return classes
  }

  async clearAdvancedFilters() {
    this.getBackofficeFarmaciaStore.clearFiltro()
    this.getBackofficeFarmaciaStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    this.clearLoadingRequest()
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  displayStatusSituacaoFarmacia(value: string) {
    return formatStatusSituacaoFarmacia(value)
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  /**
   * ========== COMENTÁRIO E LEMBRETE ==========
   */


  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  async showComentario(solicitacaoId: string) {
    this.loadingComentario = solicitacaoId
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentario = ''
  }

  surgerySolicitationHasIntegrationError(solicitacao: AgendamentoSolicitacaoItem) {
    const actions = solicitacao.acoes
    return actions.possuiComentariosCriticaIntegracaoOperadora || actions.possuiComentariosErrosIntegracaoOperadora || solicitacao.possuiComentarioDeErro
  }

  showBackofficeChatCommentDetails(actions: Acoes) {
    const simplifiedCommentPermission = actions.utilizaExibicaoDeComentarioSimplificado
    return !simplifiedCommentPermission
  }

  async abrirChatSolicitacaoComentario(surgerySolicitation: AgendamentoSolicitacaoItem) {
    this.loadingComentario = surgerySolicitation.id
    this.chatSolicitacaoComentarioStore.reset()

    await this.chatSolicitacaoComentarioStore.openChatModal(surgerySolicitation)

    this.ga('backoffice-farmacia', 'abrir-chat-solicitacao-comentario')
    this.loadingComentario = ''
  }

  async openChat(surgerySolicitationData) {
    const chatData = {
      solicitationId: surgerySolicitationData.id,
      chatArea: 'agendamento',
      recipientName: surgerySolicitationData.medicoNome,
      senderId: this.$user.profile.sub,
      senderName: this.$user.profile.name,
    }

    this.backofficeModalChatStore.reset()
    await this.backofficeModalChatStore.openChatModal(chatData)

    this.ga('backoffice-chat', 'abrir-chat')
  }

  lembreteColorDisplay(lembrete: LembreteEnum) {
    return lembreteColor(lembrete)
  }

  /**
   * ========== PAGINAÇÃO ==========
   */

  get getPagina() {
    return this.getBackofficeFarmaciaStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeFarmaciaStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeFarmaciaStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeFarmaciaStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficeFarmaciaStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getBackofficeFarmaciaStore.loadAgendamentosMedicoSearch()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    await this.init()
    EventBus.$on('setLembrete', value => this.getBackofficeFarmaciaStore.setLembreteStatus(value))
  }

  /**
   * ============ MODAIS E BOTÕES ==============
   */

  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getAutorizacaoStore() {
    return getModule(AgendamentoBackofficeAutorizacaoStore, this.$store)
  }

  async showModalTriagem(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const { hospitalId } = agendamentoCirurgia
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingRealizarTriagem = solicitacaoId

    let response = await this.agendamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)

      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        const { paciente: patientData } = response.data
        const { convenioId: healthInsuranceById } = patientData

        await this.getBackofficeGlobalStore.getHealthInsuranceById({ hospitalId, healthInsuranceById })

        this.getBackofficeGlobalStore.setModal({ name: 'triagem', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-triagem')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarTriagem = ''
  }

  async showModalPreAgendamento(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const { hospitalId } = agendamentoCirurgia
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingRealizarPreAgendamento = solicitacaoId

    let response = await this.agendamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'preAgendamento', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-pre-agendamento')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarPreAgendamento = ''
  }

  async showModalRevisaoCirurgica(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const { hospitalId } = agendamentoCirurgia
    const solicitacaoId = agendamentoCirurgia.id

    // Set solicitation data from list in BackofficeGlobalStore
    this.getBackofficeGlobalStore.setSolicitationFromList(agendamentoCirurgia as Solicitacao)

    this.loadingRealizarRevisaoCirurgica = solicitacaoId

    let response = await this.agendamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'revisaoCirurgica', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-revisao-cirurgica')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarRevisaoCirurgica = ''
  }

  async backofficeFinalizaSolicitacaoNaFarmacia(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    this.loadingFinalizaSolicitacaoNaFarmacia = agendamentoCirurgia.id
    const response = await this.getBackofficeFarmaciaStore.backofficeFinalizaSolicitacaoNaFarmacia(agendamentoCirurgia)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      this.loadingFinalizaSolicitacaoNaFarmacia = ''
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação concluída com sucesso.', icon: 'done', color: '#2E7D32' })
    await this.getBackofficeFarmaciaStore.loadAgendamentosMedicoSearch(agendamentoCirurgia.id)
    this.loadingFinalizaSolicitacaoNaFarmacia = ''
  }

  async showModalPendenciaAdministrativa(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const { hospitalId } = agendamentoCirurgia
    const solicitacaoId = agendamentoCirurgia.id

    // Set solicitation data from list in BackofficeGlobalStore
    this.getBackofficeGlobalStore.setSolicitationFromList(agendamentoCirurgia as Solicitacao)

    this.loadingPendenciaAdministrativa = solicitacaoId

    let response = await this.agendamento.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'pendenciaAdministrativa', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-pendencia-administrativa')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingPendenciaAdministrativa = ''
  }

  async showModalVisualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizar = agendamentoCirurgia.id

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-agendamento', 'visualizar')
    this.loadingVisualizar = ''
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async showModalAutorizacao(agendamentoCirurgia: AgendamentoCirurgia) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    const solicitacaoId = agendamentoCirurgia.id
    this.getAutorizacaoStore.setAgendamentoCirurgia(agendamentoCirurgia)

    const solicitacao: any = {
      solicitacaoId: agendamentoCirurgia.id,
      etapa: 'autorizacao',
    }

    await this.getAutorizacaoStore.getSolicitacaoByEtapa(solicitacao)
    await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)

    this.getAutorizacaoStore.setShowModalAutorizacao(true)
    EventBus.$emit('clearLoadingRequest')
    this.ga('backoffice-autorizacao', 'abrir-modal-autorizacao')
  }

  async openModalFlow(agendamento: AgendamentoCirurgia) {
    const params: any = {
      solicitacaoId: agendamento.id,
    }

    await this.getAutorizacaoStore.getSolicitacaoByEtapa(params)

    // eslint-disable-next-line default-case
    switch (this.getAutorizacaoStore.solicitacao.situacao.key) {
      case SituacaoEnum.PreAgendamento:
        await this.showModalPreAgendamento(agendamento)
        break

      case SituacaoEnum.Enviado:
        await this.showModalTriagem(agendamento)
        break

      case SituacaoEnum.EmTriagem:
        await this.showModalTriagem(agendamento)
        break

      case SituacaoEnum.RevisaoCirurgica:
        await this.showModalRevisaoCirurgica(agendamento)
        break

      case SituacaoEnum.PendenciaAdministrativa:
        await this.showModalPendenciaAdministrativa(agendamento)
        break

      case SituacaoEnum.EmAutorizacao:
        await this.showModalAutorizacao(agendamento)
        break
    }
  }

  async atualizarTriagem(agendamentoCirurgia: AgendamentoCirurgia) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getAutorizacaoStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.ga('backoffice-agendamento', 'atualizar-triagem')
    EventBus.$emit('clearLoadingRequest')
  }

  async visualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getAutorizacaoStore.setAgendamentoCirurgia(agendamentoCirurgia)
    this.getAutorizacaoStore.setDisabled(true)
    const solicitacao: any = {
      solicitacaoId: agendamentoCirurgia.id,
    }

    await this.getAutorizacaoStore.getSolicitacaoByEtapa(solicitacao)
    await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
    this.getAutorizacaoStore.setShowModalAutorizacao(true)
    EventBus.$emit('clearLoadingRequest')
    this.ga('backoffice-autorizacao', 'visualizar-modal-autorizacao')
  }

  columnSelectionMenu: boolean = false

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-farmacia-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-farmacia-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })

    await this.getBackofficeFarmaciaStore.loadAgendamentosMedicoSearch()
    this.readyState = true
    this.getTableHeaders()
    EventBus.$emit('clearLoadingRequest')
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficeFarmaciaStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  beforeDestroy() {
    this.getBackofficeFarmaciaStore.clearFiltro()
    this.getBackofficeFarmaciaStore.setFilterOn(false)
    this.getBackofficeFarmaciaStore.setTodosOsStatus(false)
    this.getBackofficeFarmaciaStore.setTodosOsStatusDaArea(false)
    this.getBackofficeFarmaciaStore.resetSituacoes()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }
}
